import * as Mui from '@material-ui/core';
import { ArrowBack, ArrowForward } from '@material-ui/icons';
import { Form, Formik } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import * as Yup from 'yup';
import BreadcrumbContainer from "../../../../components/breadcrumb";
import { addOrganization, getAllOrganization, getCountryList } from '../../../../reduxs/actions';
import { ManageCatelog } from './catalog/manage-catelog';
import { OnboardReview } from './onboard-review';
import { OrganizationProfile } from './organization-profile';
import { OrganizationOnboardStepper } from './stepper';

export const OrganizationOnboard = () => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const { organizations, loading } = useSelector(state => state.organization);


    useEffect(() => {
        dispatch(getAllOrganization());
    }, [dispatch])

    const schema = Yup.object().shape({
        name: Yup.string()
            .required(t("AUTH.VALIDATION.REQUIRED_FIELD"))
            .test('unique-organization-name', t("ORGANIZATION.FORM.NAME_EXISTS"), function (value) {
                if (!value) return true;
                // Check if organizations list exists and check org name insensitively
                const exists = (Array.isArray(organizations) ? organizations : []).some(org =>
                    org?.name?.trim().toLowerCase() === value.trim().toLowerCase()
                );
                return !exists;
            })
            .nullable(),
        number: Yup.string()
            .required(t("AUTH.VALIDATION.REQUIRED_FIELD"))
            .nullable(),
        adminUser: Yup.array().of(
            Yup.object().shape({
                name: Yup.string()
                    .required(t("AUTH.VALIDATION.REQUIRED_FIELD"))
                    .nullable(),
                email: Yup.string()
                    .email(t("AUTH.VALIDATION.INVALID_EMAIL"))
                    .required(t("AUTH.VALIDATION.REQUIRED_FIELD"))
                    .nullable(),
            })
        ),
        streetName: Yup.string()
            .max(100, t("AUTH.VALIDATION.MAX_LENGTH", {
                name: t("ORGANIZATION.FORM.PLACEHOLDER.STREET_NAME"),
                max: 100
            }))
            .nullable(),
        streetNumber: Yup.string()
            .max(50, t("AUTH.VALIDATION.MAX_LENGTH", {
                name: t("ORGANIZATION.FORM.PLACEHOLDER.STREET_NUMBER"),
                max: 50
            }))
            .nullable(),
        postalCode: Yup.string()
            .max(100, t("AUTH.VALIDATION.MAX_LENGTH", {
                name: t("ORGANIZATION.FORM.PLACEHOLDER.POSTAL_CODE"),
                max: 100
            }))
            .nullable(),
        city: Yup.string()
            .max(100, t("AUTH.VALIDATION.MAX_LENGTH", {
                name: t("ORGANIZATION.FORM.PLACEHOLDER.CITY"),
                max: 100
            }))
            .nullable(),
        region: Yup.string()
            .max(100, t("AUTH.VALIDATION.MAX_LENGTH", {
                name: t("ORGANIZATION.FORM.PLACEHOLDER.REGION"),
                max: 100
            }))
            .nullable(),
        // organizations: Yup.array().of(Yup.string()).min(1, t("AUTH.VALIDATION.REQUIRED_FIELD")).required(t("AUTH.VALIDATION.REQUIRED_FIELD")).defined(),
        // categories: Yup.array().of(
        //     Yup.object().shape({
        //         parentCategory: Yup.object().shape({
        //             id: Yup.number()
        //                 .required(t("AUTH.VALIDATION.REQUIRED_FIELD"))
        //                 .nullable(),
        //             name: Yup.string()
        //                 .required(t("AUTH.VALIDATION.REQUIRED_FIELD"))
        //                 .nullable(),
        //         }),
        //         subCategories: Yup.array().of(
        //             Yup.object().shape({
        //                 id: Yup.number()
        //                     .required(t("AUTH.VALIDATION.REQUIRED_FIELD"))
        //                     .nullable(),
        //                 name: Yup.string()
        //                     .required(t("AUTH.VALIDATION.REQUIRED_FIELD"))
        //                     .nullable(),
        //                 products: Yup.array().of(
        //                     Yup.object().shape({
        //                         id: Yup.number()
        //                             .required(t("AUTH.VALIDATION.REQUIRED_FIELD"))
        //                             .nullable(),
        //                         name: Yup.string()
        //                             .required(t("AUTH.VALIDATION.REQUIRED_FIELD"))
        //                             .nullable(),
        //                     })
        //                 )
        //             })
        //         )
        //     })
        // ),
    });


    const initialValues = {
        name: "",
        number: "",
        adminUser: [{ name: "", email: "" }],
        status: "",
        websiteId: "",
        streetName: "",
        streetNumber: "",
        postalCode: "",
        city: "",
        region: "",
        countryId: 160,
        activeStep: 0,
        categories: [],
        selectedSubCategory: null,
        organizations: [],
        currOrganizations: [],
    }

    const onSubmit = (values) => {
        if (loading) return;
        const updatedValues = {
            ...values,
            categories: values.categories.map((category) => ({
                ...category,
                subCategories: category.subCategories.map((subCat) => ({
                    ...subCat,
                    products: subCat.products.map((product) => ({
                        id: product.uuid,
                        orgId: product.orgId,
                        name: product.name,
                    }))
                }))
            }))
        }

        dispatch(addOrganization(updatedValues, history, location));
    }


    return <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={onSubmit}
    >
        {(props) => (
            <OrganizationOnboardComp formikProps={props} />
        )}
    </Formik>
}


export const OrganizationOnboardComp = ({ formikProps }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { loading } = useSelector(state => state.organization);


    useEffect(() => {
        // dispatch(getConfigChoice("organizationStatus"));
        dispatch(getCountryList());

    }, [dispatch])

    const stepValidation = {
        '0': [],
        '1': ['name', 'number', 'adminUser'],
        '2': ['name', 'number', 'adminUser'],
        '3': [],
    }



    const setActiveStep = async (step) => {
        if (loading) return;
        const errors = await formikProps.validateForm();
        const stepErrors = stepValidation[step].map(field => errors[field]).filter(error => error !== undefined);
        if (stepErrors.length > 0) {
            formikProps.handleSubmit();
        } else {
            if (step === 3) {
                formikProps.handleSubmit();
                return;
            }
            formikProps.setFieldValue("activeStep", step);
        }

    }



    return <>
        <BreadcrumbContainer
            title={t("PERMISSIONS.modules.organizationManagement")}
            paths={[
                {
                    title: t("PERMISSIONS.sections.organization"),
                    page: `/organization`,
                },
                {
                    title: t("PERMISSIONS.actions.add"),
                },
            ]}
        />

        <Form className="default-form">
            <Mui.Card className="default-card">
                <Mui.Typography
                    component="h4"
                    variant="h4"
                    className="mb-1 font-weight-normal"
                >
                    {t("ORGANIZATION.ONBOARD.TITLE")}
                </Mui.Typography>
                <Mui.Typography
                    component="h6"
                    variant="h6"
                    className="mb-4 font-weight-normal text-color-grey"
                >
                    {t("ORGANIZATION.ONBOARD.SUBTITLE")}
                </Mui.Typography>
                <OrganizationOnboardStepper activeStep={formikProps.values.activeStep} setActiveStep={setActiveStep} />
                <Mui.Box className="mt-5">
                    {[
                        <OrganizationProfile key={0} formikProps={formikProps} />,
                        <ManageCatelog key={1} formikProps={formikProps} />,
                        <OnboardReview key={2} formikProps={formikProps} />,
                    ].map((component, index) => (
                        <Mui.Box key={index} className={`${index === formikProps.values.activeStep ? 'd-block' : 'd-none'}`}>
                            {component}
                        </Mui.Box>
                    ))}
                </Mui.Box>
                <Mui.Box className='mt-5 d-flex justify-content-between'>
                    {formikProps.values.activeStep > 0 ? <Mui.Button
                        variant="outlined"
                        color="primary"
                        className='btn-default'
                        disabled={loading}
                        onClick={() => formikProps.setFieldValue("activeStep", formikProps.values.activeStep - 1)}
                    >
                        <ArrowBack className='mr-1' />
                        {t("ORGANIZATION.ONBOARD.CTA.BACK")}
                    </Mui.Button> : <Mui.Box />}
                    <Mui.Button
                        variant="contained"
                        color="primary"
                        className='btn-default'
                        loading={loading}
                        disabled={loading}
                        onClick={() => setActiveStep(formikProps.values.activeStep + 1)}
                    >
                        {formikProps.values.activeStep === 2 ? t("ORGANIZATION.ONBOARD.CTA.SUBMIT") : t("ORGANIZATION.ONBOARD.CTA.NEXT")}
                        {loading && <Mui.CircularProgress color="secondary" size={24} />}
                        <ArrowForward className='ml-1' />
                    </Mui.Button>
                </Mui.Box>
            </Mui.Card>
        </Form>

    </>
}


